export const enum Currency {
  USD = 'usd',
  EUR = 'eur',
  AUD = 'aud',
  MXN = 'mxn',
  BRL = 'brl',
  JPY = 'jpy',
  TRY = 'try',
  PLN = 'pln',
  GBP = 'gbp',
}

export const CURRENCY_SYMBOLS = {
  [Currency.USD]: '$',
  [Currency.EUR]: '€',
  [Currency.AUD]: 'AU$',
  [Currency.MXN]: 'MX$',
  [Currency.BRL]: 'R$',
  [Currency.JPY]: '¥',
  [Currency.TRY]: '₺',
  [Currency.PLN]: 'zł',
  [Currency.GBP]: '£',
}

export const DEFAULT_CURRENCY = Currency.USD

export const ZERO_DECIMAL_CURRENCIES = [
  'gnf',
  'pyg',
  'rwf',
  'jpy',
  'bif',
  'kmf',
  'krw',
  'clp',
  'mga',
  'ugx',
  'djf',
  'vnd',
  'vuv',
  'xaf',
  'xof',
  'xpf',
]
